module.exports = __webpack_public_path__ + "static/media/29ADMSPC12.fcb94e19.jpg";